import React from 'react';
import { Navigate } from 'react-router-dom';
import NotificationCenter from './components/NotificationCenter';
import { useAuth } from './context/AuthContext';

export default function NotificationsPage() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-cream-50 py-8 dark:bg-navy-900">
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <h1 className="mb-2 text-3xl font-black text-navy-900 dark:text-cream-50">Alerts</h1>
          <p className="text-sm text-navy-600 dark:text-cream-300">
            Track score movement, fresh intelligence, public records, social activity, and community contributions across your watchlist.
          </p>
        </div>

        <NotificationCenter />
      </div>
    </div>
  );
}
